import { createSagaActionTypes } from '../../../utils/actionFactory';

export const GET_DATA_LIMITS_WITH_USAGE = 'GET_DATA_LIMITS_WITH_USAGE';

export const actions = createSagaActionTypes('DATALIMITS_USAGE', [
  GET_DATA_LIMITS_WITH_USAGE
]);
